import { render, staticRenderFns } from "./appTodoList.vue?vue&type=template&id=746b75ba"
import script from "./appTodoList.vue?vue&type=script&lang=js"
export * from "./appTodoList.vue?vue&type=script&lang=js"
import style0 from "./appTodoList.vue?vue&type=style&index=0&id=746b75ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports